import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { MemberDataService } from './services/member-data.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  groupId: string;
  showMemberList = sessionStorage.getItem('showMemberList') !== 'false';
  constructor(
    private router: Router,
    private userService: UserService,
    private dataService: MemberDataService
  ) { }

  ngOnInit(): void {
    this.groupId = this.dataService.selectedGroupID;

    if(this.groupId == undefined || this.groupId == null)
    {
      this.groupId = this.userService.user.accountNumber;
    }
    
    if (sessionStorage.getItem('showDocuments') === 'true'){
      const documentTypes = sessionStorage.getItem('documentTypes') ?? '';
      this.userService.setSelectedGroup(this.groupId, documentTypes).subscribe({
        next: () => console.log('User group updated to:', this.groupId),
        error: (err) => console.error('Failed to update user group ', err)
      });
    }
   
  }

}
